import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ZhihuOutlinedSvg from "@ant-design/icons-svg/es/asn/ZhihuOutlined";
import AntdIcon from "../components/AntdIcon";
var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZhihuOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ZhihuOutlined.displayName = 'ZhihuOutlined';
}
export default /*#__PURE__*/React.forwardRef(ZhihuOutlined);